var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m50.4962,86.8609c-12.1612-.0061-23.5214-6.0654-30.3008-16.1617.1515-10.1015,20.1992-15.6541,30.3008-15.6541s30.1493,5.5564,30.3008,15.6541c-6.7793,10.0963-18.1396,16.1556-30.3008,16.1617m0-71.7105c8.3673,0,15.1504,6.7831,15.1504,15.1504s-6.7831,15.1504-15.1504,15.1504-15.1504-6.7831-15.1504-15.1504,6.7831-15.1504,15.1504-15.1504M50.4962,0C22.6058.0021-.0021,22.6134,0,50.5038c.0021,27.8904,22.6134,50.4983,50.5038,50.4962,27.8889-.0021,50.4962-22.6111,50.4962-50.5S78.3904,0,50.5,0c-.0013,0-.0025,0-.0038,0Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar04);
export default __webpack_public_path__ + "static/media/avatar-04.7ee926c3d0b23c12dad1612d93163b2d.svg";
export { ForwardRef as ReactComponent };